let splitTitle = (title, splitter = '<br />') => {
	let half = Math.floor(title.length / 2)

	return title.split(/\s/).reduce((res, part, i, parts) => {
		let nextPart = parts[i + 1] || ''

		if(i === 0) {
			res = part
		} else if((res + part).length >= half && res.length <= half) {
			res += splitter + part
		} else {
			res += ' ' + part
		}
		return res
	}, '')
}

export default splitTitle


/** WEBPACK FOOTER **
 ** ./src/scripts/components/SimpleTableApp/splitTitle.js
 **/